import gql from 'graphql-tag';

export const GrantAccessDialogLoaderQuery = gql`
	query GrantAccessDialogLoaderQuery($contentId: ID!, $accountId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				title
			}
		}
		user(id: $accountId) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
	}
`;
